<template>
  <div class="upload-list">
    <div>
      <div class="upload-list-item" v-for="(file, index) in files" :key="index">
        <template v-if="file.active || file.progress !== '0.00'">
          <Progress v-if="file.active || file.progress !== '0.00'" :percent="parsePercentage(file.progress)" :status="getStatus(file)" hide-info></Progress>
          <div class="upload-list-cover" v-if="!isViewOnly">
            <Icon type="ios-trash-outline" @click.native="handleRemove(file, index)"></Icon>
          </div>
        </template>
        <template v-else>
          <img ref="preview-img" :src="file.thumb || file.url" v-preview="file.thumb || file.url" />
          <div class="upload-list-cover">
            <Icon v-if="file.success && file.fileId" type="ios-eye-outline" @click.native="handleView(index)"></Icon>
            <Icon type="ios-trash-outline" @click.native="handleRemove(file, index)" v-if="!isViewOnly"></Icon>
          </div>
        </template>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { appConst, $url } from "@/lib";
import ImageView from "vue-picture-preview";
export default {
  name: "cmp-upload-image",
  components: { ImageView },
  props: {
    files: {
      type: Array,
      default() {
        return [];
      },
    },
    isViewOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      showUrl: "",
    };
  },
  mounted() {},

  methods: {
    show(index) {
      // 显示特定index的图片，使用ref
      this.$refs.previewer.show(index);
    },
    handleView(index) {
      this.$refs["preview-img"][index].click();
    },

    handleRemove(file, index) {
      this.$emit("on-file-remove", { file, index });
    },
    parsePercentage(val) {
      return parseInt(val, 10);
    },
    getStatus(file) {
      if (!file.success && file.error && file.error != "") return "wrong";
      if (file.progress === "100.00") return "success";
      return "normal";
    },
  },
};
</script>

<style scoped lang="stylus">
.isInline {
  display: inline;
}

.upload-list {
  display: inline;

  /* float: left; */
  .upload-list-item {
    display: inline-block;
    width: 120px;
    height: 120px;
    line-height:120px;
    text-align: center;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;

    &:hover {
      .upload-list-cover {
        display: block;
      }
    }

    img {
      max-width: 100%;
      max-height: 100%;
    }

    .upload-list-cover {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.6);

      i {
        color: #fff;
        font-size: 30px;
        cursor: pointer;
        margin-top: 40%;
      }
    }
  }
}
</style>
